/* eslint-disable */
import {
  Layout,
  Row,
  Col,
  Card,
  Typography,
  Button,
  Space,
  Select,
  DatePicker,
  message,
  Tooltip,
  Drawer,
  Radio,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import api from "@/utils/api";
import http from "@/utils/http";
import "./component/index.scss";
import dayjs from "dayjs";
import { CustomTable } from "@/hocComponents";
import declineIcon from "@/assets/images/icons/decline.png";
import riseIcon from "@/assets/images/icons/rise.png";
import PropertyBreakdown from "./component/PropertyBreakdown";
import { InfoCircleOutlined } from "@ant-design/icons";
export default function DashboardRequest() {
  const { Header, Content } = Layout;
  ``;
  const { Title } = Typography;
  const { Option } = Select;
  const [activeOwnerRecord, setActiveOwnerRecord] = useState(null);
  const [ownerOptions, setOwnerOptions] = useState([]);
  const [selectedOwners, setSelectedOwners] = useState([]);
  const [year, setYear] = useState();
  const [ownerTableList, setOwnerTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [ownerSelectLoading, setOwnerSelectLoading] = useState(false);
  const [showPropertyTable, setShowPropertyTable] = useState(false);
  const [lastUpdatedDate, setLastUpdatedDate] = useState(null);
  const [nextUpdateDate, setNextUpdateDate] = useState(null);
  const currentYear = dayjs().format("YYYY");
  const [dateMode, setDateMode] = useState("year");
  const [period, setPeriod] = useState(currentYear);
  const [ownerYear, setOwnerYear] = useState({
    period_start_min: "",
    period_end_max: "",
  });

  const [activeOwnerId, setActiveOwnerId] = useState(null);
  const normalizeOwnerIds = (ownerIds) => {
    if (ownerIds === "" || ownerIds == null) return "";
    if (Array.isArray(ownerIds)) return ownerIds.join(",");
    return ownerIds;
  };

  const formatYoYPct = (pct) => {
    if (pct === null || pct === undefined) return "";
    const num = (pct * 100).toFixed(1);
    const sign = pct > 0 ? "+" : "";
    return `${sign}${num}%`;
  };

  const pickTrendIcon = (trend) =>
    trend === "DOWN" ? (
      <img src={declineIcon} className="stat-card-icon" />
    ) : (
      <img src={riseIcon} className="stat-card-icon" />
    );
  const defaultStatisticCards = [
    {
      key: "grossRent",
      title: "Gross Rent",
      value: "-",
      subText: "",
      icon: null,
      positive: true,
    },
    {
      key: "rent_collected",
      title: "Rent Collected",
      value: "-",
      subText: "",
      icon: null,
      positive: true,
    },
    {
      key: "other_collected",
      title: "Other Collected",
      value: "-",
      subText: "",
      icon: null,
      positive: true,
    },
    {
      key: "expenses",
      title: "Expenses",
      value: "-",
      subText: "",
      icon: null,
      positive: false,
    },
    {
      key: "bankCredit",
      title: "Debt",
      value: "-",
      subText: "",
      icon: null,
      positive: true,
    },
    {
      key: "cashFlow",
      title: "Cash Flow",
      value: "-",
      subText: "",
      icon: null,
      positive: true,
    },
  ];

  const columns = [
    {
      title: "Owners",
      dataIndex: "owner_code",
      sortterMultiple: 2,
      render: (text, record) => {
        const highlightId = record.owner_id ?? "__ALL__";
        return (
          <Tooltip title={record?.owner_name}>
            <Button
              type="link"
              className={`owner-total-link ${
                activeOwnerId === highlightId ? "owner-total-link-active" : ""
              }`}
              onClick={() => handleTotalClick(record)}
            >
              {text}
            </Button>
          </Tooltip>
        );
      },
    },
    {
      title: "Gross Rent",
      dataIndex: "gross_rent_fmt",
      sortterMultiple: 2,
    },
    {
      title: "Rent Collected",
      dataIndex: "rent_collected_fmt",
      sortterMultiple: 2,
    },
    {
      title: "Other Collected",
      dataIndex: "other_collected_fmt",
      sortterMultiple: 2,
    },

    {
      title: "Expense",
      dataIndex: "expense_fmt",
      sortterMultiple: 2,
    },
    {
      title: "Debt",
      dataIndex: "debt_fmt",
      sortterMultiple: 2,
    },
    {
      title: "Cash Flow",
      dataIndex: "cash_flow_fmt",
      sortterMultiple: 2,
      // isAmountFlag: true,
    },
    {
      title: "Dep. Not in Bank",
      dataIndex: "",
      sortterMultiple: 2,
    },
    {
      title: "Exp. Not Cashed",
      dataIndex: "",
      sortterMultiple: 2,
    },
    {
      title: "Bank Credit",
      dataIndex: "",
      sortterMultiple: 2,
    },
    {
      title: "Bank Debit",
      dataIndex: "",
      sortterMultiple: 2,
    },
    {
      title: "Contri / Distri",
      dataIndex: "",
      sortterMultiple: 2,
    },
    // {
    //   title: "Cash On hand",
    //   dataIndex: "",
    //   sortterMultiple: 2,
    // },
  ];

  // DatePicker
  const handleYearChange = async (date, dateString, skipReset = false) => {
    setPeriod(dateString || undefined);

    if (!skipReset) {
      // setSelectedOwners([]);
      setOwnerTableList([]);
      // setOwnerOptions([]);
    }

    if (!dateString) return;

    setOwnerSelectLoading(true);
    try {
      const response = await http.get(api.getOwnerDictList_2, {
        year: dateString,
      });
      if (response?.code === "1") {
        setOwnerOptions(response.data || []);
      } else {
        setOwnerOptions([]);
      }
    } catch {
      setOwnerOptions([]);
    } finally {
      setOwnerSelectLoading(false);
    }
  };
  // Select
  const handleOwnerChange = (values = []) => {
    // 如果选中了 all
    if (values.includes("all")) {
      setSelectedOwners(["all"]);
      return;
    }

    // 否则，正常选其他（自动排除 all）
    const filteredValues = values.filter((v) => v !== "all");
    setSelectedOwners(filteredValues);

    if (filteredValues.length === 0) {
      setOwnerTableList([]);
    }
  };

  const handleOwnerSubmit = () => {
    if (!period) {
      message.warning("Please select period first");
      return;
    }

    if (!selectedOwners || selectedOwners.length === 0) {
      message.warning("Please select at least one owner");
      setOwnerTableList([]);
      return;
    }

    const payload = selectedOwners.includes("all")
      ? { period, ownerIds: "" }
      : { period, ownerIds: selectedOwners };

    fetchOwnerTable(payload);

    getCardData(payload).then((res) => {
      const arr = buildStatisticCards(res);
      setStatisticCards(arr);
    });
  };
  const handleTotalClick = (record) => {
    if (!period) {
      message.warning("Please select year first");
      return;
    }

    const rawOwnerId = record.owner_id;
    const highlightId = rawOwnerId ?? "__ALL__";

    setShowPropertyTable(true);

    setActiveOwnerId(highlightId);
    setActiveOwnerRecord(record);
  };
  const fetchOwnerTable = async ({ period, ownerIds }) => {
    if (!period) {
      setOwnerTableList([]);
      return;
    }
    const normalizedOwnerIds = normalizeOwnerIds(ownerIds);
    setTableLoading(true);
    try {
      const params = {
        period,
        ownerIds: normalizedOwnerIds,
      };
      const response = await http.get(api.getOwnerData, { params });
      if (response?.code === "1") {
        const yearInfo = {
          period_start_min: response?.data?.period_start_min || "",
          period_end_max: response?.data?.period_end_max || "",
        };
        setOwnerYear(yearInfo);
        const list = (response.data.rows || []).map((item, index) => ({
          ...item,
          key: item.id || item.ownerId || index,
        }));
        setOwnerTableList(list);
      } else {
        console.log("getOwnerData error:", response);
        setOwnerTableList([]);
        message.error(response?.msg);
      }
    } catch (e) {
      console.error(e);
      setOwnerTableList([]);
    } finally {
      setTableLoading(false);
    }
  };

  const cardConfigByKey = defaultStatisticCards.reduce((map, card) => {
    map[card.key] = card;
    return map;
  }, {});
  const apiFieldToCardKey = {
    gross_rent: "grossRent",
    other_collected: "other_collected",
    rent_collected: "rent_collected",
    expenses: "expenses",
    debt: "bankCredit",
    cash_flow: "cashFlow",
  };
  const buildStatisticCards = (data) => {
    const c = data?.cards || {};

    const safe = (obj) =>
      obj || { value_formatted: "-", yoy_pct: null, trend: "UP" };

    const periodLabel =
      data?.period_from && data?.period_to
        ? `${data.period_from} - ${data.period_to}`
        : "";

    const prevPeriodLabel =
      data?.prev_period_from && data?.prev_period_to
        ? `${data.prev_period_from} - ${data.prev_period_to}`
        : "";

    const finalPeriodLabel =
      periodLabel && prevPeriodLabel
        ? `${periodLabel} vs ${prevPeriodLabel}`
        : "";

    const buildCard = (apiField, cardKey) => {
      const base = cardConfigByKey[cardKey];
      if (!base) return null;

      const metric = safe(c[apiField]);

      return {
        key: base.key,
        title: base.title,
        positive: base.positive,
        value: metric.value_formatted,
        subText: formatYoYPct(metric.yoy_pct),
        subLabel: finalPeriodLabel,
        trend: metric.trend,
        icon: pickTrendIcon(metric.trend),
      };
    };

    const cards = [
      buildCard("gross_rent", apiFieldToCardKey.gross_rent),
      buildCard("rent_collected", apiFieldToCardKey.rent_collected),
      buildCard("other_collected", apiFieldToCardKey.other_collected),
      buildCard("expenses", apiFieldToCardKey.expenses),
      buildCard("debt", apiFieldToCardKey.debt),
      buildCard("cash_flow", apiFieldToCardKey.cash_flow),
    ];

    return cards.filter(Boolean);
  };

  // handleOwnerSubmit 调用
  const getCardData = async ({ year, ownerIds } = {}) => {
    try {
      const normalizedOwnerIds =
        typeof ownerIds === "undefined"
          ? undefined
          : normalizeOwnerIds(ownerIds);

      const params = {};
      if (typeof year !== "undefined") params.year = year;
      if (typeof normalizedOwnerIds !== "undefined") {
        params.ownerIds = normalizedOwnerIds;
      }

      const hasParams = Object.keys(params).length > 0;

      const res = hasParams
        ? await http.get(api.getCardData, { params })
        : await http.get(api.getCardData);

      if (res?.code === "1") {
        return res.data;
      }

      message.error(res?.msg || "Request error");
      return { cards: {} };
    } catch (err) {
      console.error(err);
      message.error("Request error");
      return { cards: {} };
    }
  };
  // 隐藏 PropertyBreakdown 组件
  const handleClose = () => {
    setShowPropertyTable(false);
  };

  // 请求获取更新时间的接口
  const fetchUpdateTime = async () => {
    try {
      const response = await http.get(api.getUpdateTime);
      if (response?.code === "1") {
        setLastUpdatedDate(response.data.lastDate);
        setNextUpdateDate(response.data.nextDate);
      } else {
        setError("Failed to fetch update times.");
      }
    } catch (err) {
      setError("Request error.");
    } finally {
    }
  };
  useEffect(() => {
    fetchUpdateTime();
  }, []);

  const [statisticCards, setStatisticCards] = useState(defaultStatisticCards);
  useEffect(() => {
    getCardData().then((res) => {
      const arr = buildStatisticCards(res);
      setStatisticCards(arr);
    });
  }, []);
  useEffect(() => {
    const currentYear = dayjs().format("YYYY");

    setPeriod(currentYear);

    handleYearChange(null, currentYear, true).then(() => {
      setSelectedOwners(["all"]);

      fetchOwnerTable({
        period: currentYear,
        ownerIds: "",
      });
    });
  }, []);

  return (
    <div className="dashboard-layout">
      <Header className="dashboard-header">
        <div className="dashboard-header-left">
          <Title level={4} style={{ margin: 0 }}>
            Dashboard{" "}
            {lastUpdatedDate && nextUpdateDate && (
              <span
                style={{ marginLeft: "16px", color: "#555", fontSize: "14px" }}
              >
                <strong>Last Updated Date:</strong> {lastUpdatedDate} |{" "}
                <strong>Next Update Date:</strong> {nextUpdateDate}
              </span>
            )}
          </Title>
          {/* <div className="dashboard-header-subtitle">
            Summarizes the overall financial status of the owner and the
            property.
          </div> */}
        </div>
      </Header>

      <Content className="dashboard-content">
        <div className="dashboard-wrapper drawer-host">
          {/* 顶部统计卡片 */}
          <Row gutter={[16, 16]} className="dashboard-stat-row">
            {statisticCards.map((card) => (
              <Col className="dashboard-stat-col" key={card.key} flex="1">
                <Card className="stat-card">
                  <Space
                    align="start"
                    style={{ width: "100%", justifyContent: "space-between" }}
                  >
                    <div>
                      <div className="stat-card-title">{card.title}</div>
                      <span className="stat-card-value">{card.value}</span>

                      <div className="stat-card-subtext">
                        {card.subText && (
                          <>
                            <span className="stat-card-subtext-value">
                              {card.subText}
                            </span>
                          </>
                        )}

                        {card.subLabel && (
                          <Tooltip
                            title={
                              <div>
                                <div style={{ fontWeight: 600 }}>
                                  YoY comparison period:
                                </div>
                                <div>{card.subLabel}</div>
                              </div>
                            }
                          >
                            <InfoCircleOutlined
                              style={{
                                fontSize: 16,
                                marginLeft: 8,
                                cursor: "pointer",
                              }}
                            />
                          </Tooltip>
                        )}
                      </div>
                    </div>

                    <Button
                      shape="circle"
                      icon={card.icon}
                      type="text"
                      className="stat-card-icon-btn"
                    />
                  </Space>
                </Card>
              </Col>
            ))}
          </Row>

          {/* Financial Overview */}
          <Card className="section-card financial-card">
            <div className="section-card-header">
              <div>
                <div className="section-card-title">Financial Overview</div>
                {ownerYear.period_start_min && ownerYear.period_end_max && (
                  <div className="section-card-period-label">
                    Data source: {ownerYear.period_start_min} -{" "}
                    {ownerYear.period_end_max}
                  </div>
                )}
              </div>

              <Space>
                <Radio.Group
                  value={dateMode}
                  onChange={(e) => {
                    setDateMode(e.target.value);
                    setPeriod(null); // 切换模式清空
                  }}
                >
                  <Radio.Button value="year">Year</Radio.Button>
                  <Radio.Button value="month">Month</Radio.Button>
                </Radio.Group>

                <DatePicker
                  picker={dateMode}
                  value={
                    period
                      ? dayjs(period, dateMode === "year" ? "YYYY" : "YYYY-MM")
                      : null
                  }
                  format={dateMode === "year" ? "YYYY" : "YYYY-MM"}
                  onChange={(date) => {
                    if (!date) {
                      setPeriod(null);
                      return;
                    }

                    setPeriod(
                      dateMode === "year"
                        ? date.format("YYYY")
                        : date.format("YYYY-MM"),
                    );
                  }}
                />

                <Select
                  mode="multiple"
                  value={selectedOwners}
                  allowClear
                  showSearch
                  optionFilterProp="label"
                  onChange={handleOwnerChange}
                  loading={ownerSelectLoading}
                  maxTagCount={5}
                  placeholder="Select Owner"
                  style={{ minWidth: 360 }}
                >
                  {[
                    ...(ownerOptions.length
                      ? [{ ownerId: "all", name: "All Owners" }]
                      : []),
                    ...ownerOptions,
                  ].map((item) => (
                    <Option
                      key={item.ownerId}
                      value={item.ownerId}
                      label={item.name}
                    >
                      {item.name}
                    </Option>
                  ))}
                </Select>
                <Button
                  type="primary"
                  onClick={handleOwnerSubmit}
                  loading={tableLoading}
                  disabled={ownerSelectLoading || !period}
                >
                  Submit
                </Button>
              </Space>
            </div>
            <div className="financial-table-container">
              <CustomTable
                tableLoading={tableLoading}
                columns={columns}
                tableList={ownerTableList}
                scroll={{ y: "100%" }}
              />
            </div>
          </Card>

       <Drawer
  placement="bottom"
  open={showPropertyTable}
  onClose={handleClose}
  height="100%"
  closable={false}
  title={null}
  getContainer={false}
  mask={false}
  rootClassName="property-drawer"
>
  <PropertyBreakdown
    period={period}
    ownerId={activeOwnerId}
    ownerRecord={activeOwnerRecord}
    visible={showPropertyTable}
    onClose={handleClose}
  />
</Drawer>
        </div>
      </Content>
    </div>
  );
}
